import { render } from "./License.vue?vue&type=template&id=d982d51a&scoped=true"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"

import "./License.vue?vue&type=style&index=0&id=d982d51a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d982d51a"]])

export default __exports__